import { PrivateInterceptor } from "../../../../Base/interceptors/PrivateInterceptor"; 



// OBTENER REQUISAS PARA LIBERAR REQUISAS
export const getAprobarRequisa = async () => {
  const respuesta = await PrivateInterceptor(`Compras/AprobarRequisa`, "GET");
  return respuesta;
};
